import { fromEvent } from "rxjs";
import { IAnalyticsService } from "../services/interfaces/analyticsService";
import { IMessagingService } from "../services/interfaces/messagingService";
import { Component } from "./component";
import { AnchorListInteractionEvent } from "../models/analytics/anchorListInteractionEvent";
import { AnalyticsEventName } from "../enums/analyticsEventName";

class AnchorListComponent extends Component
{
    private analyticsService: IAnalyticsService;

    constructor(componentEl: HTMLElement, messagingService: IMessagingService, analyticsService: IAnalyticsService) {
        super(componentEl, messagingService);
        this.analyticsService = analyticsService;

        const anchorListItems = componentEl.querySelectorAll<HTMLElement>(".js-anchorList-item");
        anchorListItems.forEach((el) => {
            const click$ = fromEvent(el, 'click');
            click$.subscribe(() => {
                const anchorTitle = el.dataset["anchorLinkTitle"];
                const analyticsData = new AnchorListInteractionEvent(anchorTitle, "navigate to section");

                this.analyticsService.RecordEvent(AnalyticsEventName.AnchorListEvent, analyticsData);
            });
        });


        const backToMenuLinks = componentEl.querySelectorAll<HTMLElement>(".js-anchorList-back");
        backToMenuLinks.forEach((el) => {
            const click$ = fromEvent(el, 'click');
            click$.subscribe(() => {
                const anchorTitle = el.dataset["anchorLinkBack"];
                const analyticsData = new AnchorListInteractionEvent(anchorTitle, "navigate to menu");

                this.analyticsService.RecordEvent(AnalyticsEventName.AnchorListEvent, analyticsData);
            });
        });
    }
}

export { AnchorListComponent }